export default __webpack_public_path__ + "60ab42a795ad85b47ac674e1e6c69e3b.png";